import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  url = '@cec-api/dashboard';

  constructor(private http: HttpClient) {}

  getCards(): Promise<any> {
    return this.http.get(`${this.url}/cards`).toPromise();
  }
}
